export default __webpack_public_path__ + "static/media/icon-3.30b01de7.png";